import React, { useState } from 'react';
import { Plus, Minus, Search, Facebook, Instagram, GitBranch as BrandTiktok,Users, Layers } from 'lucide-react';
import { useNavigate } from "react-router-dom"; // Import useNavigate
// Platform filter for selecting social platforms
const PlatformFilter = ({ platforms = [], selectedPlatform, onSelect }) => {
  const getIcon = (platform) => {
    switch (platform.toLowerCase()) {
      case 'facebook':
        return <Facebook style={{ width: '20px', height: '20px' }} />;
      case 'instagram':
        return <Instagram style={{ width: '20px', height: '20px' }} />;
      case 'tiktok':
        return (
          <svg style={{ width: '20px', height: '20px' }} viewBox="0 0 24 24" fill="currentColor">
            <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
          </svg>
        );
      default:
        return null;
    }
  };

  if (!platforms.length) {
    return <p style={{ color: '#6b7280', marginBottom: '8px' }}>No platforms available.</p>;
  }

  return (
    <div style={{ marginBottom: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
        <Layers style={{ width: '20px', height: '20px', color: '#374151' }} />
        <span style={{ fontSize: '18px', fontWeight: '600', color: '#374151' }}>Select Platform</span>
      </div>

      <div style={{ display: 'flex', gap: '16px' }}>
        {platforms.map((platform) => (
          <button
            key={platform}
            onClick={() => onSelect(platform.toLowerCase())}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 32px',
              borderRadius: '12px',
              border: '1px solid',
              backgroundColor: selectedPlatform === platform.toLowerCase() ? '#65ccb7' : 'transparent',
              color: selectedPlatform === platform.toLowerCase() ? 'white' : '#4b5563',
              borderColor: selectedPlatform === platform.toLowerCase() ? '#65ccb7' : '#e5e7eb',
              fontSize: '16px',
              fontWeight: '500',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
            }}
          >
            {getIcon(platform)}
            <span style={{ textTransform: 'capitalize' }}>{platform}</span>
          </button>
        ))}
      </div>
    </div>
  );
};


 const RelationType = ({ selected, onChange }) => {
  const [showTooltip, setShowTooltip] = useState(false); // Move useState inside the component

const [showTooltipMutual, setShowTooltipMutual] = useState(false); // Add this line


  return (
    
    <div
    
      style={{
        display: "flex",
        gap: "120px",
        marginBottom: "32px",
        padding: "16px",
        backgroundColor: "#f3f4f6",
        borderRadius: "12px",
      }}
    >
      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          cursor: "pointer",
          position: "relative",
        }}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <input
          type="radio"
          name="relationType"
          value="direct"
          checked={selected === "direct"}
          onChange={(e) => onChange(e.target.value)}
          style={{ position: "absolute", opacity: 0 }}
        />
        <div
          style={{
            width: "18px",
            height: "18px",
            border: "2px solid #e5e7eb",
            borderRadius: "50%",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {selected === "direct" && (
            <div
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: "#65ccb7",
                borderRadius: "50%",
                position: "absolute",
                top: "4px",
                left: "4px",
              }}
            />
          )}
        </div>
        <img
          src="/icons/O_T_M_Black.png"
          alt="One-to-Many"
          style={{ width: "25px", height: "25px" }}
        /> {/* One-to-Many icon added */}
        <span style={{ fontSize: "14px", color: "#4b5563" }}>Direct</span>

        {/* Tooltip - Appears on Hover */}
        {showTooltip && (
          <div
          style={{
            position: "absolute",
            top: "30px",
            right: "0px", // Adjusted to keep tooltip inside screen bounds
            backgroundColor: "#333",
            color: "#fff",
            padding: "8px",
            borderRadius: "6px",
            fontSize: "12px",
            whiteSpace: "normal",
            maxWidth: "3500px", // Ensures better readability
            textAlign: "center",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,
            width:"120%"
          }}
        >
          <strong>One to many relation</strong> <br />
         
          <strong>NOTE: User can select/add</strong><strong style={{ color: "#65ccb7" }}>  Only ONE </strong>Profile.
        </div>
        
        )}
      </label>

      
     

<label
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
    cursor: "pointer",
    position: "relative", // Needed for tooltip positioning
  }}
  onMouseEnter={() => setShowTooltipMutual(true)}
  onMouseLeave={() => setShowTooltipMutual(false)}
>
  <input
    type="radio"
    name="relationType"
    value="mutual"
    checked={selected === "mutual"}
    onChange={(e) => onChange(e.target.value)}
    style={{ position: "absolute", opacity: 0 }}
  />
  <div
    style={{
      width: "18px",
      height: "18px",
      border: "2px solid #e5e7eb",
      borderRadius: "50%",
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    {selected === "mutual" && (
      <div
        style={{
          width: "10px",
          height: "10px",
          backgroundColor: "#65ccb7",
          borderRadius: "50%",
          position: "absolute",
          top: "4px",
          left: "4px",
        }}
      />
    )}
  </div>
  
  <img
          src="/icons/M_T_M_Black.png"
          alt="Many-to-Many"
          style={{ width: "25px", height: "25px" }}
        />{/* Many-to-Many icon added */}
  <span style={{ fontSize: "14px", color: "#4b5563" }}>Mutual</span>

  {/* Tooltip - Appears on Hover */}
  {showTooltipMutual && (
    <div
      style={{
        position: "absolute",
        top: "30px",
        right: "0px", // Adjust to prevent cut-off
        backgroundColor: "#333",
        color: "#fff",
        padding: "8px",
        borderRadius: "6px",
        fontSize: "12px",
        whiteSpace: "normal",
        maxWidth: "3500px", // Better readability
        textAlign: "center",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        zIndex: 1000,
        width: "120%"
      }}
    >
      <strong>Many to Many Relation</strong> <br />
     
      <strong>NOTE:</strong> User can select/add  
      <strong style={{ color: "#65ccb7" }}> MULTIPLE </strong> Profiles.
    </div>
  )}
</label>

    </div>
  );
};
// ProfileList component for displaying profiles
const ProfileList = ({ profiles, onSelect, isSelected, relationType, selectedCount, platform, searchQuery, showNotFound = false }) => {
  const navigate = useNavigate(); 
  const filteredProfiles = searchQuery && showNotFound
    ? profiles.filter(profile => 
        profile.username.toLowerCase().includes(searchQuery.toLowerCase()) ||
        profile.full_name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : profiles;

  if (filteredProfiles.length === 0 && showNotFound) {
    return (
      <div
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: "12px",
        padding: "16px",
        textAlign: "center",
      }}
    >
      <p style={{ color: "#6b7280", marginBottom: "8px" }}>
        Profile not found, add them in the profiling section{" "}
        <span
          onClick={() => navigate("/profiling")} // Navigate to Profiling.js
          style={{
            color: "#65ccb7",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          here
        </span>
      </p>
    </div>
    );
  }

  const getProfileImage = (profile) => {
    switch(platform) {
      case 'facebook':
        return profile.profile_photo_url;
      case 'instagram':
        return profile.profile_photo_url;
      case 'tiktok':
        return profile.profile_avatar_url;
      default:
        return profile.profile_photo_url;
    }
  };

  return (
    <div style={{ borderRadius: '12px', overflow: 'hidden', maxHeight: '300px', overflowY: 'auto', marginBottom: '20px' }}>
      <div style={{ maxHeight: '220px', overflowY: 'auto', scrollbarWidth: 'thin', scrollbarColor: '#e5e7eb' }}>
        {filteredProfiles.map((profile, index) => {
          const uniqueKey = `${platform}-${profile.username || profile.id}-${index}`;
          return (
            <div
              key={uniqueKey}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '16px',
                borderBottom: '1px solid #e5e7eb',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease',
                ':hover': { backgroundColor: '#f3f4f6' }
              }}
              onClick={() => onSelect(profile)}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{ position: 'relative' }}>
                  <img
                    src={getProfileImage(profile)}
                    alt={profile.username}
                    style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      objectFit: 'cover',
                      border: '2px solid #65ccb7'
                    }}
                  />
                  <div style={{
                    position: 'absolute',
                    top: '-6px',
                    right: '-6px',
                    width: '24px',
                    height: '24px',
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                  }}>
                    <span style={{
                      fontSize: '10px',
                      fontWeight: 'bold',
                      color: platform === 'facebook' ? '#1877f2' : platform === 'instagram' ? '#e1306c' : platform === 'tiktok' ? 'black' : 'black'
                    }}>
                      {platform.charAt(0)}
                    </span>
                  </div>
                </div>
                <div>
                  <p style={{ fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>{profile.username}</p>
                  <p style={{ fontSize: '14px', color: '#6b7280' }}>{profile.full_name}</p>
                  {/* Add target index */}
          <p style={{ fontSize: '12px', color: '#FF0000', fontWeight: '500' }}>
            Target {index + 1}
          </p>
                </div>
              </div>
              <button
                onClick={() => onSelect(profile)}
                style={{
                  padding: '8px',
                  borderRadius: '50%', // Keeps the circular shape
                  backgroundColor: 'transparent', // Ensure the background is transparent
                  color: 'black', // Keep the icon color black
                  cursor: 'pointer', // Cursor indicates it is clickable
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '16px',
                  border: 'none', // Removes the border
                  boxShadow: 'none', // Removes any shadow if present
                  outline: 'none', // Removes the outline that might show when clicked
                }}
                disabled={relationType === 'direct' && !isSelected(profile) && selectedCount > 0}
              >
                {isSelected(profile) ? <Minus style={{ width: '24px', height: '24px' }} /> : <Plus style={{ width: '24px', height: '24px' }} />}
              </button>

            </div>
          );
        })}
      </div>
    </div>
  );
};

// ProfileSection Component for displaying profile selection
const ProfileSection = (props) => {
  const {
    data = { platforms: [] },
    selectedProfiles,
    onProfileSelect,
    onProfileRemove,
    relationType,
    onRelationTypeChange,
    selectedPlatform,
    onPlatformChange
  } = props;

  const [searchQuery, setSearchQuery] = useState('');
  const platforms = data?.platforms?.map(p => p.name) || [];
const currentPlatform = data?.platforms?.find(p => p.name.toLowerCase() === selectedPlatform);
const profiles = currentPlatform?.profiles || [];

const handleProfileSelect = (profile) => {
  if (!profile) {
    console.error("Profile is null or undefined");
    return;
  }
  if (relationType === 'direct') {
    onProfileSelect([profile]);
  } else {
    const isAlreadySelected = selectedProfiles.some(p => p.username === profile.username);
    if (!isAlreadySelected) {
      onProfileSelect([...selectedProfiles, profile]);
    }
  }
};

const handleProfileRemove = (profile) => {
  if (!profile) {
    console.error("Profile is null or undefined");
    return;
  }
  onProfileRemove(selectedProfiles.filter(p => p.username !== profile.username));
};

  const handlePlatformChange = (platform) => {
    onPlatformChange(platform);
    setSearchQuery('');
    onProfileSelect([]);
  };

  const handleRelationTypeChange = (newType) => {
    onRelationTypeChange(newType);
    if (newType === 'direct') {
      onProfileSelect([]);
    }
  };

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
<h3
  style={{
    fontSize: "20px",
    fontWeight: "700",
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
    gap: "10px", // Spacing between icon and text
  }}
>
  <Users style={{ width: "24px", height: "24px"}} /> {/* Icon added */}
  PROFILES
</h3>
      <h2 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "24px" , color: "#707070"}}>
        Mapping of Profiles with respect to Followers.
      </h2>


      <PlatformFilter
        platforms={platforms}
        selectedPlatform={selectedPlatform}
        onSelect={handlePlatformChange}
      />

      <RelationType
        selected={relationType}
        onChange={handleRelationTypeChange}
      />

      <div style={{ flex: 1, overflow: 'hidden' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
          <div>
            <div style={{ marginBottom: '24px' }}>
              <div style={{ position: 'relative' }}>
                <input
                  type="text"
                  placeholder="Search profiles..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  style={{
                    width: '100%',
                    paddingLeft: '48px',
                    paddingRight: '24px',
                    paddingTop: '12px',
                    paddingBottom: '12px',
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',
                    outline: 'none',
                    boxSizing: 'border-box',
                    fontSize: '16px'
                  }}
                />
                <Search style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', width: '20px', height: '20px', color: '#d1d5db' }} />
              </div>
            </div>
            <h4 style={{ fontSize: '16px', fontWeight: '600', color: '#1f2937', marginBottom: '12px' }}>Available Profiles</h4>
            <ProfileList
              profiles={profiles}
              onSelect={handleProfileSelect}
              isSelected={profile => selectedProfiles.some(p => p.username === profile.username)}
              relationType={relationType}
              selectedCount={selectedProfiles.length}
              platform={selectedPlatform}
              searchQuery={searchQuery}
              showNotFound={true}
            />
          </div>
          <div>
            <h4 style={{ fontSize: '16px', fontWeight: '600', color: '#1f2937', marginBottom: '12px' }}>Selected Profiles</h4>
            <ProfileList
              profiles={selectedProfiles}
              onSelect={handleProfileRemove}
              isSelected={() => true}
              relationType={relationType}
              selectedCount={selectedProfiles.length}
              platform={selectedPlatform}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileSection;
